const env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
    return [ 'ci', 'dev', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
} );

function getURL( url ) {
    return url.toLowerCase().replace( '(env.)', env ? env + '.' : '' );
}

export const idURL = getURL( 'https://(env.)api.biw.cloud/v1/id' );
export const cmxURL = getURL( 'https://(env.)api.biw.cloud/v2/cmx' );
export const rosterURL = getURL( 'https://(env.)api.biw.cloud/v1/roster' );
export const kameURL = getURL( 'https://(env.)api.biw.cloud/kameapi/graphql' );
export const notificationsUrl = getURL( 'https://(env.)api.biw.cloud/notification-service/v1' );

export const marketPlaceURL = getURL( 'https://(env.)api.biw.cloud/catalog/sso/services/v1' );
export const imageServiceURL = getURL( 'https://(env.)api.biw.cloud/v1/images' );
export const cashierURL = getURL( 'https://(env.)api.biw.cloud/v1/cashier' );
